var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNailgunGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6697 55.2002L91.5097 116.01H67.0597L42.2197 55.2002H66.6697Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6697 55.2002C66.6697 55.2002 71.5297 67.1002 81.8697 67.1002C88.2397 67.1002 90.2197 74.4602 85.1797 78.3402C85.1797 78.3402 89.1797 79.5802 89.1797 83.6302V89.5702H80.9997L85.1897 100.15H102.37V67.1002H107.66C111.166 67.1002 114.528 65.7073 117.008 63.2281C119.487 60.7489 120.88 57.3863 120.88 53.8802C120.88 50.374 119.487 47.0114 117.008 44.5322C114.528 42.053 111.166 40.6602 107.66 40.6602H66.6597V55.2002H66.6697Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3098 53.8802H37.5898V45.9502H69.3098",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2698 49.9199H27.0098",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6496 116.01L50.8096 55.2002",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.46 69.75H53.72",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 82.9702H57.68",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8697 67.1001C79.7397 68.5401 79.7397 72.7601 81.1797 76.3301",
    stroke: "#1F323D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNailgunGrey);
export default __webpack_public_path__ + "static/media/nailgun_grey.14c2a2b9e8f315e714919ea8d78cb1f3.svg";
export { ForwardRef as ReactComponent };